import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BookOpen, Check } from 'lucide-react';
import { motion } from 'framer-motion';

interface OnboardingButtonProps {
  isCompleted: boolean;
}

export default function OnboardingButton({ isCompleted }: OnboardingButtonProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/onboarding-tutorial');
  };

  return (
    <motion.button
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      onClick={handleClick}
      className={`w-full p-6 rounded-xl border-2 transition-all relative overflow-hidden ${
        isCompleted 
          ? 'bg-green-50 border-green-200 hover:bg-green-100/50' 
          : 'bg-amber-50 border-amber-200 hover:bg-amber-100/50'
      }`}
    >
      <div className="flex items-start space-x-4">
        <div className={`rounded-full p-2 ${
          isCompleted ? 'bg-success/10' : 'bg-amber-400/20'
        }`}>
          {isCompleted ? (
            <Check className="w-6 h-6 text-success" />
          ) : (
            <BookOpen className="w-6 h-6 text-amber-500" />
          )}
        </div>
        <div className="flex-1">
          <h3 className={`font-semibold ${
            isCompleted ? 'text-gray-700' : 'text-gray-900'
          }`}>
            {isCompleted ? 'Onboarding Tutorial Completed' : 'Start Onboarding Tutorial'}
          </h3>
          <p className={`mt-1 text-sm ${
            isCompleted ? 'text-gray-500' : 'text-gray-600'
          }`}>
            {isCompleted 
              ? 'You have completed the onboarding tutorial. Click to review it again.' 
              : 'Learn how to use the platform and get the most out of your feedback experience.'}
          </p>
          <span className={`inline-block mt-2 text-sm font-medium ${
            isCompleted ? 'text-success' : 'text-amber-600'
          }`}>
            {isCompleted ? 'Review Tutorial →' : 'Start Now →'}
          </span>
        </div>
      </div>
    </motion.button>
  );
}